import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=e09ec52e&scoped=true&"
import script from "./Subjects.vue?vue&type=script&lang=ts&"
export * from "./Subjects.vue?vue&type=script&lang=ts&"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=e09ec52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09ec52e",
  null
  
)

/* custom blocks */
import block0 from "./Subjects.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VSheet})
